import {
  textoRelacaoObra,
  textoVencimento,
  vencimentoEmDestaque,
} from "../../hooks/nova-obra.condicoes";
import { hojeBrasilia } from "@/modules/obras/hoje-brasilia";
import { useMemo } from "react";
import { useObraEmbarcacoes, useObraLimitesClasse } from "@/modules/obras";
import type { LimitesClasseDialogProps } from "./types-limites-classe-dialog";

export function useLimitesClasseDialog({
  embarcacaoId,
  periodo,
  onClose,
}: LimitesClasseDialogProps) {
  const limites = useObraLimitesClasse(embarcacaoId);
  const embarcacoes = useObraEmbarcacoes();
  const embarcacaoNome = embarcacoes.data.find((item) => item.id === embarcacaoId)?.nome ?? "";
  const hoje = useMemo(() => hojeBrasilia(), []);

  return {
    limites,
    embarcacaoNome,
    hoje,
    periodo,
    onClose,
    linhas: limites.data.map((limite) => {
      const relacao = periodo ? textoRelacaoObra(limite.dataLimite, periodo, hoje) : null;
      const critico = relacao?.relacao === "VENCIDO" || relacao?.relacao === "ANTES_DO_INICIO";

      return {
        chave: `${limite.vistoria}-${limite.dataLimite}`,
        descricao: limite.descricao,
        dataLimite: limite.dataLimite,
        critico,
        destaque: critico || vencimentoEmDestaque(limite.dataLimite, hoje),
        relacao,
        vencimento: textoVencimento(limite.dataLimite, hoje),
      };
    }),
  };
}
